module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-hero.acd9c6b9.jpg";